import { useEffect, useState } from "react";
import { getPLPBottomBanner } from "../services/products.service";

export default function CustomerFavourite() {
    const [customerFavourite, setCustomerFavourite] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchPLPBottomBanner = async () => {
        setLoading(true);
        setError(null);

        try {
            const res = await getPLPBottomBanner();

            if (res?.data?.status === 200) {
                setCustomerFavourite(res.data.data);
            } else {
                setError("Failed to load banner");
            }
        } catch (err) {
            console.error("PLP Bottom Banner Error:", err);
            setError(err.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPLPBottomBanner();
    }, []);
    if (loading) return null; // or skeleton
    if (error || !customerFavourite) return null;

    return (
        <section className="obsession-section-pd">
            <div className="obsession-content-pd">
                <div className="obsession-text-pd">
                    <h2>
                        What makes Obsessions <br /> a customer <em>favourite</em>.
                    </h2>

                    <div className="obsession-columns">
                        {customerFavourite.content?.map((item, index) => {
                            const [title, description] = Object.entries(item)[0];
                            return (
                                <div className="obsession-col" key={index}>
                                    <h4>{title}</h4>
                                    <p>{description}</p>
                                </div>
                            );
                        })}
                    </div>
                </div>

                <div className="obsession-images">
                    <div className="obsession-img-wrapper">
                        <img
                            className="on-image-one"
                            src={customerFavourite.media?.[0]?.large}
                            alt="Customer favourite"
                        />
                        <span className="obsession-tag top-left">
                            {customerFavourite.tags?.[0]?.top_left}
                        </span>
                        <span className="obsession-tag top-right">
                            {customerFavourite.tags?.[1]?.top_right}
                        </span>
                    </div>

                    <div className="obsession-img-wrapper">
                        <img
                            className="on-image-two"
                            src={customerFavourite.media?.[1]?.small}
                            alt="Customer favourite"
                        />
                        <span className="obsession-tag bottom">
                            {customerFavourite.tags?.[2]?.bottom_right}
                        </span>
                    </div>
                </div>
            </div>
        </section>
    );
}
